var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlockSquare2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Padlock Square 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Padlock-Square-2--Streamline-Core.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6429 6.28564H3.35721C2.72604 6.28564 2.21436 6.79732 2.21436 7.4285V14.2856C2.21436 14.9168 2.72604 15.4285 3.35721 15.4285H13.6429C14.2741 15.4285 14.7858 14.9168 14.7858 14.2856V7.4285C14.7858 6.79732 14.2741 6.28564 13.6429 6.28564Z",
    fill: "#D9E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.6429 6.28564H3.35721C2.72604 6.28564 2.21436 6.79732 2.21436 7.4285V14.2856C2.21436 14.9168 2.72604 15.4285 3.35721 15.4285H13.6429C14.2741 15.4285 14.7858 14.9168 14.7858 14.2856V7.4285C14.7858 6.79732 14.2741 6.28564 13.6429 6.28564Z",
    stroke: "#024776",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3229 1.74859C10.9548 1.37374 10.5154 1.07644 10.0306 0.874264C9.54575 0.672082 9.0253 0.569117 8.5 0.57145C7.43913 0.57145 6.42171 0.992877 5.67158 1.74302C4.92143 2.49317 4.5 3.51059 4.5 4.57145V6.28573",
    stroke: "#024776",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockSquare2);
export default __webpack_public_path__ + "static/media/Padlock Square 2.b2628b276501a165b326f27f223ff133.svg";
export { ForwardRef as ReactComponent };